/**
 * @author Fernando Ruano
 * @file reduces.js
 * @description Global Application reducer.
 */

// Dependencies
import { Map } from 'immutable';

// Constants
import {
  SET_LOADING,
  SET_RESPONSE,
  SET_USER,
  SET_TITLE,
  SET_PATIENT_INDICATORS,
  SET_PATIENT_EVENT_TYPE,
  SET_CLINIC_ID,
  SET_LAST_VERSIA_UPDATE,
  SET_CLINICS,
  SET_INSURERS,
  SET_TABLE_DATA
} from './constants';

// Initial state
export const initialState = Map({
  user: false,
  loading: false,
  title: Map({
    main: false,
    sub: false
  }),
  response: Map({
    type: false,
    title: false,
    message: false
  }),
  patientIndicators: [],
  patientEventType: null,
  clinicId: null
});

export default function appReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADING:
      return state.set('loading', payload.loading);
    case SET_USER:
      return state.set('user', payload.user);
    case SET_TITLE:
      return state
        .setIn(['title', 'main'], payload.main)
        .setIn(['title', 'sub'], payload.sub);
    case SET_RESPONSE:
      return state
        .setIn(['response', 'type'], payload.type)
        .setIn(['response', 'title'], payload.title)
        .setIn(['response', 'message'], payload.message);
    case SET_PATIENT_INDICATORS:
      return state.set('patientIndicators', payload.patientIndicators);
    case SET_PATIENT_EVENT_TYPE:
      return state.set('patientEventType', payload.patientEventType);
    case SET_CLINIC_ID:
      return state.set('clinicId', payload.clinicId);
    case SET_LAST_VERSIA_UPDATE:
      return state.set('lastVersiaUpdate', payload.lastVersiaUpdate);
    case SET_CLINICS:
      return state.set('clinics', payload.clinics);
    case SET_INSURERS:
      return state.set('insurers', payload.insurers);
    case SET_TABLE_DATA:
      return state.set('tableConfig', payload.tableConfig);
    default:
      return state;
  }
}
